import humanizeDuration from 'humanize-duration';

const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: 'shortEn',
  languages: {
    shortEn: {
      y: () => 'y',
      mo: () => 'mo',
      w: () => 'w',
      d: () => 'd',
      h: () => 'h',
      m: () => 'm',
      s: () => 's',
      ms: () => 'ms'
    }
  }
});

const secondsToMilliseconds = (value) => value * 1000;

export const humanizeTimeSpan = (value, options = { delimiter: ' ', unit: 's' } ) => {
  let processedValue = value;

  if(options.unit === 's') {
    processedValue = secondsToMilliseconds(value);
  }

  return shortEnglishHumanizer(processedValue, { delimiter: options.delimiter });
};



// WEBPACK FOOTER //
// ./src/utilities/dateTime.js